export enum AppModelFamilies {
  Carbon = 'Carbon',
  CarbonMobile = 'Carbon Mobile',
  'Carbon Mobile' = 'CarbonMobile',
}
